import { GetTimeFromTimestamp, MaterialAmountType, WarehouseMovement } from '@dave/types';

export class WarehouseMovementEntity {
    constructor(
        public Id: number = null,
        public PartnerId: number = null,
        public Type: MaterialAmountType = null,
        public UserId: number = null,
        public DocumentId: number = null,
        public LegerImportId: number = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
    ) {}
    public static EntityName = 'WarehouseMovement';

    public Clone(override: Partial<WarehouseMovementEntity> = {}): WarehouseMovementEntity {
        const attr = { ...this, ...override };
        return Object.assign(new WarehouseMovementEntity(), attr);
    }
}

export function WarehouseMovementEntityFromBackend(res: WarehouseMovement): WarehouseMovementEntity {
    return new WarehouseMovementEntity(
        res.Id && +res.Id,
        res.PartnerId && +res.PartnerId,
        res.Type,
        res.UserId && +res.UserId,
        res.DocumentId && +res.DocumentId,
        res.LegerImportId && +res.LegerImportId,
        res.CreatedAt && GetTimeFromTimestamp(+res.CreatedAt),
        res.UpdatedAt && GetTimeFromTimestamp(+res.UpdatedAt),
    );
}
